var $b205bafb2456c922$exports = {};
$b205bafb2456c922$exports = {
    "help": `Pomo\u{107}`,
    "info": `Informacije`
};


export {$b205bafb2456c922$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
